
  angular.
  module('quantixApp').
  component('progressIndicator', {
    template: '<i class="fa fa-caret-up upload-color bigfont" ng-if="$ctrl.isprogressed"></i><i class="fa fa-caret-down upload-fail bigfont" ng-if="!$ctrl.isprogressed"></i>',
    bindings: {
        isprogressed: '<'
    },
    controller: function TooltipTemplateController() {
      var ctrl = this;

    }
    
  });